import {
  Component, ElementRef,
  Injector,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'navbar navbar-default app-navbar';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-navbar',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmNavbar]',
  template: `<div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="btn-transparent navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <i [ngClass]="menuiconclass"></i>
      </button>
      <a class="navbar-brand" *ngIf="title || imgsrc">
        <img data-identifier="img" class="brand-image" height="20" *ngIf="imgsrc" [src]="imgsrc"/>
        <span class="title" [textContent]="title"></span>
      </a>
    </div>
    <div class="collapse navbar-collapse" #navContent>
      <ng-content></ng-content>
    </div>
  </div>`,
  providers: [
    provideAsWidgetRef(NavbarComponent)
  ],
  exportAs: 'wmNavbar',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class NavbarComponent extends StylableComponent {
  static initializeProps = register('wm-navbar');

  public menuiconclass: any;
  public title: string;
  public imgsrc: string;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

